import InboxPage from '@/pages/services/directPayments/InboxPage.vue'
import DirectPaymentsSentboxPage from '@/pages/services/directPayments/SendboxPage.vue'
import DetailPage from '@/pages/requests/detailPages/DirectPaymentDetailPage.vue'
import DirectPaymentsDraftEditPage from '@/pages/services/directPayments/TDraftEdit.vue'
import DirectPaymentsCreation from '@/pages/services/directPayments/TDirectPayments.vue'
import CreationPage from '@/pages/services/directPayments/TCreationPage.vue'
import DirectPaymentsPilotage from '@/pages/statistics/StatisticsPage.vue'
import ContactDebtorList from '@/pages/requests/ContactDebtorList.vue'
import ImportDP from '@/pages/services/directPayments/sendbox/ImportDP'
import ImportReportDP from '@/pages/services/directPayments/sendbox/ImportReportDP'

export default [
  {
    path: '/directPayments/inbox/',
    alias: [],
    component: InboxPage
  },
  {
    path: '/directPayments/sendbox/',
    alias: [],
    component: DirectPaymentsSentboxPage
  },
  {
    path: '/directPayments/sendbox/import/:importType',
    alias: [],
    component: ImportDP
  },
  {
    path: '/directPayments/sendbox/report/',
    alias: [],
    component: ImportReportDP
  },
  {
    path: '/directPayments/sendbox/:tab/',
    alias: [],
    component: DirectPaymentsSentboxPage
  },
  {
    path: '/directPayments/details/:direction/',
    alias: [],
    component: DetailPage
  },
  {
    path: '/directPayments/creation/',
    alias: [],
    component: CreationPage
  },
  {
    path: '/directPayments/contactDebtorList/',
    alias: [],
    component: ContactDebtorList
  },
  {
    path: '/directPayments/draft/edit/',
    component: DirectPaymentsDraftEditPage
  },
  {
    path: '/directPayments/newDirectPayments/',
    alias: ['/account/createPayments', '/createDirectPayments/'],
    component: DirectPaymentsCreation
  },
  {
    path: '/directPayments/pilotage/',
    alias: ['/account/pilotage/', '/pilotage/'],
    component: DirectPaymentsPilotage
  }
]



// WEBPACK FOOTER //
// ./src/routes/services/directPayments.js